:host {
    display: block;
}

.inactive-banner {
    display: none;
}
